import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { useIntl } from "react-intl";

import { type Classification } from "@/schemas";
import { getClassifications } from "@/api/classifications-api";

export const CLASSIFICATIONS_QUERY_KEY = "classifications";

const useClassificationsQuery = () => {
	const intl = useIntl();

	return () => getClassifications(intl);
};

export const useClassifications = (
	options?: Omit<UseQueryOptions<Classification[], Error>, "queryKey" | "queryFn">,
) => {
	const queryFn = useClassificationsQuery();

	return useQuery<Classification[]>({
		queryKey: [CLASSIFICATIONS_QUERY_KEY],
		queryFn,
		...options,
	});
};
